import { contains, focus, getActiveElement, isTabbable } from '../utils';
import { useUpdateEffect } from './use-update-effect';
function preventReturnFocus(containerRef) {
  var el = containerRef.current;
  if (!el) return false;
  var activeElement = getActiveElement(el);
  if (!activeElement) return false;
  if (contains(el, activeElement)) return false;
  if (isTabbable(activeElement)) return true;
  return false;
}

/**
 * Popover hook to manage the focus when the popover closes or hides.
 *
 * Moves focus to the provided "focusRef" when "visible" and "shouldFocus".
 */
export function useFocusOnHide(containerRef, options) {
  var {
    shouldFocus: shouldFocusProp,
    visible,
    focusRef
  } = options;
  var shouldFocus = shouldFocusProp && !visible;
  useUpdateEffect(() => {
    if (!shouldFocus) return;
    if (preventReturnFocus(containerRef)) {
      return;
    }
    var el = (focusRef === null || focusRef === void 0 ? void 0 : focusRef.current) || containerRef.current;
    if (el) {
      focus(el, {
        nextTick: true
      });
    }
  }, [shouldFocus, containerRef, focusRef]);
}